/**
 * Stories handled by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent, MouseEvent as ReactMouseEvent, MouseEventHandler } from 'react';
import { setCypressID } from 'src/utils/setCypressID';
import { HEADER_VERSIONS, NavbarSectionTestID } from 'src/components/ZillowNavbar/constants';
import { HeaderLink } from 'src/components/ZillowNavbar/page-frame-types/HeaderLink';
import { HeaderLinkDescription } from 'src/components/ZillowNavbar/page-frame-types/HeaderLinkDescription';
import { HeaderSubSection } from '../../../../../../page-frame-types/HeaderSubSection';
import { HomeLoansDashboardLink } from '../../../../../HomeLoansDashboardLink';
import { ZillowNavbarSectionMegaMenuContainer } from './components/ZillowNavbarSectionMegaMenuContainer';
import { ZillowNavbarSectionMegaMenuContentContainer } from './components/ZillowNavbarSectionMegaMenuContentContainer';
import { ZillowNavbarSubSectionsList } from './components/ZillowNavbarSubSectionsList';
import { ZillowNavbarSubSection } from './components/ZillowNavbarSubSection';
import { ZillowNavbarSubSectionContainer } from './components/ZillowNavbarSubSection/components/ZillowNavbarSubSectionContainer';

export type ZillowNavbarSectionDesktopMegaMenuProps = {
    subsections: HeaderSubSection[];
    zhlHost: string;
    isHomeLoansDashboardLinkRendered: boolean;
    isVertical: boolean;
    isLeftAligned: boolean;
    onMouseEnter: MouseEventHandler<HTMLDivElement>;
    testID?: NavbarSectionTestID;
    version: HEADER_VERSIONS;
    onLinkClick: (
        link: HeaderLink | HeaderLinkDescription,
        event: ReactMouseEvent<HTMLAnchorElement, MouseEvent>
    ) => void;
};

export const ZillowNavbarSectionDesktopMegaMenu: FunctionComponent<ZillowNavbarSectionDesktopMegaMenuProps> = ({
    subsections,
    isHomeLoansDashboardLinkRendered,
    zhlHost,
    isVertical,
    isLeftAligned,
    version,
    onMouseEnter,
    onLinkClick,
    testID,
}) => (
    <ZillowNavbarSectionMegaMenuContainer
        onMouseEnter={onMouseEnter}
        {...setCypressID(testID && testID.megamenu)}
        isVertical={isVertical}
        isLeftAligned={isLeftAligned}>
        <ZillowNavbarSectionMegaMenuContentContainer>
            <ZillowNavbarSubSectionsList isVertical={isVertical}>
                {isHomeLoansDashboardLinkRendered && (
                    <ZillowNavbarSubSectionContainer isVertical={isVertical}>
                        <HomeLoansDashboardLink version={version} zhlHost={zhlHost} />
                    </ZillowNavbarSubSectionContainer>
                )}
                {subsections.map((subsection, index) => (
                    <ZillowNavbarSubSection
                        isVertical={isVertical}
                        onLinkClick={onLinkClick}
                        subsection={subsection}
                        key={`${subsection.title}-${index}`}
                    />
                ))}
            </ZillowNavbarSubSectionsList>
        </ZillowNavbarSectionMegaMenuContentContainer>
    </ZillowNavbarSectionMegaMenuContainer>
);
